// #2364 (scribe-presence workstream, card C) — a stable id for THIS
// scribe-fe tab/session. lib/presence.js's file header (apps/score-api):
// "client-generated, stable for the life of one scribe-fe tab/session ...
// NOT the Cognito sub — one scribe can hold two instances (two tabs/
// devices) at once, each heartbeating separately." Persisted in
// localStorage so a reload keeps reporting as the same instance instead of
// minting a fresh presence row (and losing continuity with the old one
// until its TTL expires) on every refresh.
//
// Falls back to an in-memory id when localStorage is unavailable (private
// browsing, storage quota) — non-fatal, same storage-guarded-with-fallback
// shape as ScoreContext's loadInitial/persist.
const STORAGE_KEY = "scribe-fe.presenceInstanceId";

let memoryId = null;

function randomId() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

export function getPresenceInstanceId() {
  try {
    const existing = localStorage.getItem(STORAGE_KEY);
    if (existing) return existing;
    const fresh = randomId();
    localStorage.setItem(STORAGE_KEY, fresh);
    return fresh;
  } catch {
    if (!memoryId) memoryId = randomId();
    return memoryId;
  }
}

// #3518 Reset tablet: mint a brand-new station GUID, replacing the old one.
// The old GUID (and every row the server holds for it) is kept forever on the
// server; this tablet simply stops being that station. localStorage is wiped by
// the clear itself, so this also covers the storage-blocked in-memory fallback.
export function resetPresenceInstanceId() {
  memoryId = null;
  const fresh = randomId();
  try {
    localStorage.setItem(STORAGE_KEY, fresh);
  } catch {
    memoryId = fresh;
  }
  return fresh;
}
